/**
 * 订单相关类型定义
 */

export enum InspectionType {
  ON_SITE = 'ON_SITE', // 上门检测
  MAIL = 'MAIL', // 邮寄检测
  OUTSOURCE = 'OUTSOURCE', // 代送检测
}

export enum OrderStatus {
  // 通用状态
  DRAFT = 'DRAFT', // 暂存
  PENDING_ASSIGN = 'PENDING_ASSIGN', // 待市场部分配
  ASSIGNED_TO_CS = 'ASSIGNED_TO_CS', // 已分配客服

  // 上门检测路径
  APPOINTMENT_SET = 'APPOINTMENT_SET', // 已预约
  DISPATCHED = 'DISPATCHED', // 已派单
  IN_PROGRESS = 'IN_PROGRESS', // 检测中

  // 邮寄检测路径
  WAITING_MAIL = 'WAITING_MAIL', // 等待邮寄
  MAIL_RECEIVED = 'MAIL_RECEIVED', // 已收件
  LAB_TESTING = 'LAB_TESTING', // 实验室检测中

  // 通用后续状态
  INSPECTED = 'INSPECTED', // 已检
  REJECTED = 'REJECTED', // 退检
  BILL_GENERATED = 'BILL_GENERATED', // 已生成缴费单
  PAID = 'PAID', // 已缴费
  CERT_GENERATED = 'CERT_GENERATED', // 证书已生成
  COMPLETED = 'COMPLETED', // 已完成

  // 异常状态
  EXCEPTION = 'EXCEPTION', // 异常中
}

export enum PaymentMethod {
  WECHAT = 'WECHAT', // 微信支付
  VOUCHER = 'VOUCHER', // 上传凭证
  MONTHLY = 'MONTHLY', // 月结
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}

export enum ExceptionStatus {
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
}
